export default __webpack_public_path__ + "static/media/lk.5b5731f1.svg";